import {
  Injectable,
  Component,
  Input,
  OnInit,
  Injector,
  NgZone,
} from "@angular/core";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
/************************** interfaces************************ */
import { IHardwareVersion } from "@shared/interfaces/device.interface";
import { IparameterForUpdate } from "@shared/interfaces/request.interface";

/************************** Queries************************ */
import { DeviceQuery } from "@shared/state/device/device.query";
import { UserQuery } from "@shared/state/user/user.query";

/************************** services************************ */
import { FirestoreService } from "@shared/services/firestore.service"; //to access the firebase
import { BleCapacitorService } from "@shared/services/ble/ble-capacitor.service";
import { ModalService } from "@shared/services/modal.service";

//import { ConnectApiService } from '@shared/services/connectapi.service';

@Component({
  selector: "app-inactive-unit-modal",
  templateUrl: "./inactive-unit-modal.component.html",
  styleUrls: ["./inactive-unit-modal.component.scss"],
})
@Injectable({ providedIn: "root" })
export class InactiveUnitModalComponent implements OnInit {
  @Input()
  public hardwareVersion!: IHardwareVersion;

  public serialNumber!: string;
  public ecuName!: string;

  public hide: boolean = false;
  public becomeActive: boolean = false;
  public role$ = this.userQuery.role$;
  constructor(
    private injector: Injector,
    private modalService: ModalService,
    private deviceQuery: DeviceQuery,
    private firestoreService: FirestoreService,
    private userQuery: UserQuery,
    private modalCtrl: ModalController,
    private ngZone: NgZone,
    private router: Router, // private connectApiService: ConnectApiService
  ) {}

  ngOnInit(): void {
    //console.log('inactive model dialog');
    this.becomeActive = false;
    this.serialNumber = this.getSerialNumber(this.hardwareVersion);
    this.ecuName = this.hardwareVersion?.ecuName ?? "";
  }

  public async closeModal() {
    // console.log('close model');
    this.modalCtrl.dismiss();
    this.modalService.dismissModal("InactiveUnitModalComponent");
    this.becomeActive = false;
  }

  public async closeAppModal() {
    // console.log('close model');
    this.modalCtrl.dismiss();
    this.modalService.dismissModal("InactiveUnitModalComponent");
    this.router.navigate(["/"]);
    this.becomeActive = false;
  }

  private getSerialNumber(hardwareVersion: IHardwareVersion): string {
    switch (hardwareVersion.ecuId) {
      case 1:
        return (
          this.deviceQuery.specificParameterData(1074)?.value?.toString() ?? ""
        );
      case 2:
        return (
          this.deviceQuery.specificParameterData(2137)?.value?.toString() ?? ""
        );
      case 6:
        return (
          this.deviceQuery.specificParameterData(6008)?.value?.toString() ?? ""
        );
      default:
        return "";
    }
  }

  public async markDuplicateAsInactive(): Promise<void> {
    this.becomeActive = true;

    try {
      await this.firestoreService.setDeviceAsInactive(this.hardwareVersion);
      this.modalService.dismissModal("InactiveUnitModalComponent");
    } catch (error) {
      console.error("Could not mark duplicate as inactive", error);
    }
  }

  public markDuplicateAsSparePart() {
    //console.log('duplicate marked SparePart', this.hardwareVersion);
    this.firestoreService.setOldDeviceAsSparePart(this.hardwareVersion);
    this.firestoreService.startFirestoreLink();
    this.closeModal();
  }

  public resetUnit() {
    var parameterId = this.getSparepartParameterId(this.hardwareVersion.ecuId);

    if (parameterId) {
      var parameterForUpdate: IparameterForUpdate = {
        parameterId: parameterId,
        ecuId: this.hardwareVersion.ecuId,
        value: 1,
      };

      // this.connectApiService.writeParameterToDevice(parameterForUpdate);
      this.hide = true;
    }
  }

  private getSparepartParameterId(ecuId: number): number {
    switch (ecuId) {
      case 1:
        return 1151;
      case 2:
        return 2162;
      case 6:
        return 6107;
      default:
        return 0;
    }
  }

  public disconnect(): void {
    const currentDevice = this.deviceQuery?.currentDevice;
    const bleCapacitorService = this.injector.get(BleCapacitorService);

    bleCapacitorService
      .disconnect(currentDevice)
      .then((res) => {
        //console.log(res, 'disconnected');
        this.modalService.dismissModal("InactiveUnitModalComponent");
        this.closeAppModal();
        this.router.navigate(["/"]);
      })

      .catch((err) => {
        console.log(err, "could not disconnect");
      });
    this.modalService.dismissModal("InactiveUnitModalComponent");
    this.closeAppModal();
    this.router.navigate(["/"]);
  }
}
